/* eslint-disable react/jsx-no-bind */
import React, { useEffect } from 'react';

// routes
import { Outlet, useLocation } from 'react-router-dom';

// assets
import Sidebar from './DashboardSidebar';
import DashboardNavbar from './DashboardNavbar';


function DashboardLayout({type}) {
	const location = useLocation();
	
	const slideSidebar = () => {
		const sidebar = document.querySelector('.bottomWrapper__sidebar');
		const content = document.querySelector('.bottomWrapper__content');

		if (sidebar.classList.contains('closed')) {
			sidebar.classList.remove('closed');
			content.classList.remove('expand');
		} else {
			sidebar.classList.add('closed');
			content.classList.add('expand');
		}
	}

	useEffect(()=>{
		const content = document.querySelector('.bottomWrapper__content');

		content.scrollTo(0,0);
	},[location.pathname])

	return (
		<div className="dashboardLayout">
			{type!=='dtx006' && (
				<div className="headerWrapper">
					<DashboardNavbar type={type} slideSidebar={slideSidebar}/>
				</div>
			)}			
			<div className="bottomWrapper">
				<div className="bottomWrapper__sidebar">
					<Sidebar type={type} />
				</div>
				<div className="bottomWrapper__content" style={{height: type==='dtx006' ? '100vh' : null}}>
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default DashboardLayout;
